import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';
import { getTagIconColor, getTagIcon } from 'utils/challenge';
import { Masonry } from 'dc/Masonry';
import ActivityCard from 'challenge/common/TutorialActivityCard';
import { ActivitiesLabel, ActivitiesTitle } from '../elements';
import { TutorialWrapper, PopUp01, PopUp02 } from './elements';
import { useText } from 'common/hooks';

const deps = {
  showTutorial: state.challenge.tutorial.show,
  campaignIndicator: state.challenge.campaign.indicator,
  tutorialLength: state.challenge.tutorial.length,
  prevPopUp: sequences`challenge.tutorial.prevPopUp`,
  endTutorial: sequences`challenge.tutorial.endTutorial`,
  toggleLogTutorialActivity: sequences`challenge.tutorial.toggleLogTutorialActivity`,
};

function TutorialActivities({
  showTutorial,
  campaignIndicator,
  tutorialLength,
  prevPopUp,
  endTutorial,
  toggleLogTutorialActivity,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  switch (showTutorial) {
    case 1:
      return (
        <TutorialWrapper $highlight={showTutorial < tutorialLength}>
          <PopUp01
            title={t('challenge.tutorial.PopUp01.title')}
            text={t('challenge.tutorial.PopUp01.text')}
            nextText={t('challenge.tutorial.next')}
            onNextClick={() =>
              toggleLogTutorialActivity({
                offset: 0,
                co2: 1.61,
                popUpNumber: showTutorial + 1,
              })
            }
            onCloseClick={() => endTutorial()}
            noPrevious
            side={'right'}
            currentSlide={showTutorial}
            slideCount={tutorialLength}
          />
          <ActivitiesLabel $marginBottom="12px">
            <ActivitiesTitle
              icon={getTagIcon('tutorial')}
              color={getTagIconColor('tutorial')}
            >
              {`${t(`challenge.tags.tutorial.name`)} (1)`}
            </ActivitiesTitle>
          </ActivitiesLabel>
          <Masonry
            options={{
              paddingBottom: '24px',
            }}
            cards={[
              <ActivityCard
                key={'activity_tutorial_01'}
                className={'grid-item'}
              />,
            ]}
          />
        </TutorialWrapper>
      );
    case 2:
      return (
        <>
          <PopUp02
            title={t('challenge.tutorial.PopUp02.title')}
            text={t(`challenge.tutorial.PopUp02.text_${campaignIndicator}`)}
            backText={t('challenge.tutorial.back')}
            nextText={t('challenge.tutorial.finish')}
            onCloseClick={() => endTutorial()}
            onPreviousClick={() => prevPopUp({ popUpNumber: showTutorial - 1 })}
            onNextClick={() => endTutorial()}
            side={'right'}
            noArrow
            currentSlide={showTutorial}
            slideCount={tutorialLength}
          />
          <ActivitiesLabel $marginBottom="12px">
            <ActivitiesTitle
              icon={getTagIcon('tutorial')}
              color={getTagIconColor('tutorial')}
            >
              {`${t(`challenge.tags.tutorial.name`)} (1)`}
            </ActivitiesTitle>
          </ActivitiesLabel>
          <Masonry
            options={{
              paddingBottom: '24px',
            }}
            cards={[
              <ActivityCard
                key={'activity_tutorial_01'}
                className={'grid-item'}
              />,
            ]}
          />
        </>
      );
    case 0:
    default:
      return null;
  }
}

export default connect(deps, TutorialActivities);
